<template>
  <div class="competition-mgmt-page purchase-mgmt-page">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>产品管理</el-breadcrumb-item>
        <el-breadcrumb-item>竞品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">本品 ASIN</span>
            <el-input
              v-model="filters.commodityAsin"
              class="filter-input-asin"
              maxlength="10"
              size="small"
              clearable
              placeholder="请输入"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">竞品 ASIN</span>
            <el-input
              v-model="filters.competitionAsin"
              class="filter-input-asin"
              maxlength="10"
              size="small"
              clearable
              placeholder="请输入"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品类型</span>
            <el-select
              v-model="filters.productType"
              class="filter-select-wide"
              size="small"
              filterable
              clearable
              placeholder="全部"
            >
              <el-option
                v-for="product in productList"
                :key="product.productType"
                :label="productTypeLabel(product)"
                :value="product.productType"
              ></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="toolbar-tip">共 {{ total }} 条</span>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" :loading="loading" @click="search">查询</el-button>
            <el-button v-perm="'product:competition:save'" type="primary" size="small" plain icon="el-icon-plus" @click="openCreate">新增关系</el-button>
            <el-button size="small" @click="openOperations()">操作记录</el-button>
            <el-button size="small" icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table
          :data="rows"
          border
          stripe
          size="mini"
          row-key="id"
          :height="screenHeight"
          class="mgmt-table"
          header-cell-class-name="table-header-cell"
          v-loading="loading"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
          empty-text="暂无竞品关系"
        >
          <el-table-column label="序号" width="52" align="center">
            <template slot-scope="scope">
              {{ beginIndex + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="commodityAsin" label="本品 ASIN" min-width="130" show-overflow-tooltip></el-table-column>
          <el-table-column label="产品名称" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.productName || "-" }}</template>
          </el-table-column>
          <el-table-column label="颜色" width="88" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.productColorName || "-" }}</template>
          </el-table-column>
          <el-table-column label="型号" width="100" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.model || "-" }}</template>
          </el-table-column>
          <el-table-column prop="competitionAsin" label="竞品 ASIN" min-width="130" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productType" label="商品类型" width="88" align="center"></el-table-column>
          <el-table-column label="创建时间" width="120" align="center">
            <template slot-scope="scope">
              <div class="datetime-cell">
                <div>{{ splitDateTime(scope.row.createTime).date }}</div>
                <div class="datetime-time">{{ splitDateTime(scope.row.createTime).time }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" width="120" align="center">
            <template slot-scope="scope">
              <div class="datetime-cell">
                <div>{{ splitDateTime(scope.row.updateTime).date }}</div>
                <div class="datetime-time">{{ splitDateTime(scope.row.updateTime).time }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="168" fixed="right" align="center" class-name="action-col">
            <template slot-scope="scope">
              <div class="action-cell">
                <el-button type="text" size="small" @click="openOperations(scope.row.id)">操作记录</el-button>
                <el-button
                  v-perm="'product:competition:delete'"
                  type="text"
                  size="small"
                  class="action-btn danger"
                  :disabled="!!deleting[scope.row.id]"
                  @click="remove(scope.row)"
                >删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          background
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next"
          @current-change="changePage"
          @size-change="changeSize"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="新增竞品关系"
      :visible.sync="createVisible"
      width="520px"
      custom-class="competition-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="!saving"
      :show-close="!saving"
      @closed="invalidateValidation"
    >
      <el-form label-width="96px" size="small" :disabled="saving" @submit.native.prevent="save">
        <el-form-item label="本品 ASIN">
          <el-input v-model="editing.commodityAsin" maxlength="10" placeholder="输入本品 ASIN 后点击校验" @input="invalidateValidation">
            <el-button slot="append" :loading="validating" @click="validateProduct">校验本品</el-button>
          </el-input>
        </el-form-item>
        <el-form-item v-if="validatedAsin" label="校验结果">
          <el-tag type="success" size="mini" effect="plain">本品校验通过 · 商品类型 {{ validatedProductType }}</el-tag>
        </el-form-item>
        <el-form-item label="竞品 ASIN">
          <el-input
            v-model="editing.competitionAsin"
            maxlength="10"
            :disabled="!validatedAsin || saving"
            placeholder="本品校验通过后输入竞品 ASIN"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" :disabled="saving" @click="createVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" :disabled="!validatedAsin" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="operationsTitle" :visible.sync="operationsVisible" width="960px" custom-class="competition-dialog">
      <el-table
        :data="operationRows"
        v-loading="operationsLoading"
        border
        stripe
        size="mini"
        class="mgmt-table"
        header-cell-class-name="table-header-cell"
        empty-text="暂无操作记录"
        max-height="420"
      >
        <el-table-column prop="relationId" label="关系 ID" width="88" align="center"></el-table-column>
        <el-table-column prop="commodityAsin" label="本品 ASIN" min-width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="competitionAsin" label="竞品 ASIN" min-width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productType" label="商品类型" width="88" align="center"></el-table-column>
        <el-table-column label="操作" width="72" align="center">
          <template slot-scope="scope">
            <el-tag :type="actionTagType(scope.row.action)" size="mini" effect="plain">{{ scope.row.action || "-" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="operatorId" label="操作人 ID" width="96" align="center"></el-table-column>
        <el-table-column label="操作时间" width="120" align="center">
          <template slot-scope="scope">
            <div class="datetime-cell">
              <div>{{ splitDateTime(scope.row.createTime).date }}</div>
              <div class="datetime-time">{{ splitDateTime(scope.row.createTime).time }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="dialog-pagination">
        <el-pagination
          background
          :current-page="operationPage"
          :page-size="20"
          :total="operationTotal"
          layout="total, prev, pager, next"
          @current-change="changeOperationPage"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/request/competitionModules";
import { requestModules } from "@r";

const normalize = value => (value || "").trim().toUpperCase();
const validAsin = value => /^[A-Z0-9]{10}$/.test(normalize(value));

export default {
  data() {
    return {
      filters: { commodityAsin: "", competitionAsin: "", productType: null },
      productList: [],
      rows: [],
      total: 0,
      currentPage: 1,
      pageSize: 100,
      loading: false,
      loadSequence: 0,
      deleting: {},
      screenHeight: 400,
      createVisible: false,
      editing: { commodityAsin: "", competitionAsin: "" },
      validatedAsin: "",
      validatedProductType: null,
      validating: false,
      saving: false,
      validationSequence: 0,
      operationsVisible: false,
      operationRows: [],
      operationTotal: 0,
      operationPage: 1,
      relationId: undefined,
      operationsLoading: false,
      operationSequence: 0,
    };
  },
  computed: {
    beginIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    operationsTitle() {
      return this.relationId ? `操作记录 · 关系 ${this.relationId}` : "操作记录";
    },
  },
  created() {
    this.loadProductTypes();
    this.load();
  },
  mounted() {
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.loadSequence++;
    this.validationSequence++;
    this.operationSequence++;
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    formatTime(value) {
      return value ? new Date(value).toLocaleString("zh-CN", { hour12: false }) : "";
    },
    splitDateTime(value) {
      const text = this.formatTime(value);
      if (!text) {
        return { date: "-", time: "" };
      }
      const parts = text.trim().split(/\s+/);
      return {
        date: parts[0] || "-",
        time: parts.slice(1).join(" "),
      };
    },
    actionTagType(action) {
      if (action === "删除") {
        return "info";
      }
      if (action === "新增") {
        return "success";
      }
      return "";
    },
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const pagination = panel.querySelector(".pagination-box");
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const paginationHeight = pagination ? pagination.offsetHeight : 0;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - paginationHeight - 12;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    productTypeLabel(product) {
      if (!product || !product.productName) {
        return "";
      }
      return product.productName;
    },
    loadProductTypes() {
      requestModules.fetchParentProducts({}).then(res => {
        const list = res.ldata || [];
        this.productList = list.slice().sort((a, b) => a.productType - b.productType);
      }).catch(() => {
        this.productList = [];
      });
    },
    async load() {
      const productType = this.filters.productType;
      const sequence = ++this.loadSequence;
      this.loading = true;
      try {
        const result = await api.page({
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          commodityAsin: normalize(this.filters.commodityAsin),
          competitionAsin: normalize(this.filters.competitionAsin),
          productType: productType === "" || productType == null ? undefined : productType,
        });
        if (sequence !== this.loadSequence) {
          return;
        }
        this.rows = result.data.records || [];
        this.total = result.data.total || 0;
        if (!this.rows.length && this.currentPage > 1) {
          this.currentPage--;
          return this.load();
        }
      } catch (error) {
        if (sequence === this.loadSequence) {
          this.$message.error(error.message || "加载竞品关系失败");
        }
      } finally {
        if (sequence === this.loadSequence) {
          this.loading = false;
          this.calculateHeight();
        }
      }
    },
    search() {
      this.currentPage = 1;
      return this.load();
    },
    resetSearch() {
      this.filters = { commodityAsin: "", competitionAsin: "", productType: null };
      return this.search();
    },
    changePage(page) {
      this.currentPage = page;
      return this.load();
    },
    changeSize(size) {
      this.pageSize = size;
      return this.search();
    },
    invalidateValidation() {
      this.validationSequence++;
      this.validatedAsin = "";
      this.validatedProductType = null;
      this.validating = false;
      this.editing.competitionAsin = "";
    },
    openCreate() {
      this.invalidateValidation();
      this.editing = { commodityAsin: "", competitionAsin: "" };
      this.createVisible = true;
    },
    async validateProduct() {
      if (!validAsin(this.editing.commodityAsin)) {
        this.$message.warning("本品 ASIN 必须为 10 位字母或数字");
        return;
      }
      const commodityAsin = normalize(this.editing.commodityAsin);
      this.invalidateValidation();
      const sequence = this.validationSequence;
      this.validating = true;
      try {
        const result = await api.validateProduct(commodityAsin);
        if (sequence !== this.validationSequence || !this.createVisible) {
          return;
        }
        this.validatedAsin = commodityAsin;
        this.validatedProductType = result.data;
      } catch (error) {
        if (sequence === this.validationSequence) {
          this.$message.error(error.message || "本品校验失败");
        }
      } finally {
        if (sequence === this.validationSequence) {
          this.validating = false;
        }
      }
    },
    async save() {
      if (this.saving || !this.validatedAsin || this.validatedAsin !== normalize(this.editing.commodityAsin)) {
        return;
      }
      if (!validAsin(this.editing.competitionAsin)) {
        this.$message.warning("竞品 ASIN 必须为 10 位字母或数字");
        return;
      }
      this.saving = true;
      try {
        await api.save({
          commodityAsin: this.validatedAsin,
          competitionAsin: normalize(this.editing.competitionAsin),
        });
        this.$message.success("竞品关系已保存");
        this.createVisible = false;
        await this.search();
      } catch (error) {
        this.$message.error(error.message || "保存失败");
      } finally {
        this.saving = false;
      }
    },
    async remove(row) {
      if (this.deleting[row.id]) {
        return;
      }
      try {
        await this.$confirm(`确认删除本品 ${row.commodityAsin || "—"} 与竞品 ${row.competitionAsin} 的关系？`, "删除关系", { type: "warning" });
      } catch (error) {
        return;
      }
      this.$set(this.deleting, row.id, true);
      try {
        await api.remove(row.id);
        this.$message.success("关系已删除");
        await this.load();
      } catch (error) {
        this.$message.error(error.message || "删除失败");
      } finally {
        this.$delete(this.deleting, row.id);
      }
    },
    openOperations(relationId) {
      this.relationId = relationId;
      this.operationPage = 1;
      this.operationRows = [];
      this.operationTotal = 0;
      this.operationsVisible = true;
      return this.loadOperations();
    },
    changeOperationPage(page) {
      this.operationPage = page;
      return this.loadOperations();
    },
    async loadOperations() {
      const sequence = ++this.operationSequence;
      this.operationsLoading = true;
      try {
        const result = await api.operations({
          currentPage: this.operationPage,
          pageSize: 20,
          relationId: this.relationId,
        });
        if (sequence !== this.operationSequence) {
          return;
        }
        this.operationRows = result.data.records || [];
        this.operationTotal = result.data.total || 0;
      } catch (error) {
        if (sequence === this.operationSequence) {
          this.$message.error(error.message || "加载操作记录失败");
        }
      } finally {
        if (sequence === this.operationSequence) {
          this.operationsLoading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

.competition-mgmt-page {
  .breadcrumb-box {
    flex-shrink: 0;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border: 1px solid #ebeef5;

    .el-breadcrumb {
      line-height: 1;
      font-size: 13px;
    }
  }

  .header-box {
    padding: 10px;

    .filter-toolbar {
      margin-top: 4px;
      padding-top: 10px;
      border-top: 1px dashed #ebeef5;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .filter-actions .el-button {
      width: auto;
      min-width: auto;
      margin: 0;
    }

    .filter-item .filter-label {
      min-width: 72px;
    }

    .filter-item .filter-input-asin.el-input {
      width: 168px;
    }

    .toolbar-tip {
      color: #606266;
      font-size: 12px;
    }
  }

  .datetime-cell {
    line-height: 1.4;
  }

  .datetime-time {
    color: #909399;
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }

  .action-cell {
    flex-wrap: nowrap;
    white-space: nowrap;
  }
}

.competition-dialog {
  .dialog-pagination {
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
  }

  .datetime-cell {
    line-height: 1.4;
  }

  .datetime-time {
    color: #909399;
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }
}
</style>
